import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const emissionsLedgerService = createApi({
    reducerPath: 'emissionsLedgerService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['EmissionsLedger'],
    endpoints: (builder) => ({
        getAllEmissionsLedger: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.emissionsLedgerController.search}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        saveEmissionsLedger: builder.mutation({
            query(body) {
                const isFormData = body.payload instanceof FormData;
                return {
                    url: `${userManagement.emissionsLedgerController.save}`,
                    method: 'POST',
                    headers: isFormData
                        ? { Authorization: `Bearer ${body.token}` }
                        : { Authorization: `Bearer ${body.token}`, 'Content-Type': 'application/json' },
                    body: body.payload,
                }
            }
        }),
        updateEmissionsLedger: builder.mutation({
            query(body) {
                const isFormData = body.payload instanceof FormData;
                const id = body.id || (isFormData ? body.payload.get("id") : body.payload.id);
                return {
                    url: `${userManagement.emissionsLedgerController.update}/${id}`,
                    method: 'PUT',
                    headers: isFormData
                        ? { Authorization: `Bearer ${body.token}` }
                        : { Authorization: `Bearer ${body.token}`, 'Content-Type': 'application/json' },
                    body: body.payload,
                }
            }
        }),
        deleteEmissionsLedger: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.emissionsLedgerController.delete}/${body.id}${body.type ? `?type=${body.type}` : ""}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),
        getEmissionsLedgerById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.emissionsLedgerController.getById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        findAllEmissionsLedger: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.emissionsLedgerController.findAll}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkUploadEmissionsLedger: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.emissionsLedgerController.uploadBulk}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});

export const {
    useGetAllEmissionsLedgerMutation,
    useSaveEmissionsLedgerMutation,
    useUpdateEmissionsLedgerMutation,
    useDeleteEmissionsLedgerMutation,
    useGetEmissionsLedgerByIdMutation,
    useFindAllEmissionsLedgerMutation,
    useBulkUploadEmissionsLedgerMutation,
} = emissionsLedgerService;
